import { useNavigate } from "react-router-dom";
import { clearStoredRef, eraseCookie, getCookie } from "../../../utils/utils";
import GlobalModalComponent from "../globalModal/GlobalModalComponent";
import { userLogout } from "../../../services/auth.service";
import { logout } from "../../../redux/Slices/userProfile";
import { AppDispatch, RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import styles from "./LogoutModal.module.scss";
import MainButton from "../button/MainButton";

interface props {
  logoutConfrim: boolean;
  setLogoutConfrim: (value: boolean) => void;
}

const LogoutModal = ({ logoutConfrim, setLogoutConfrim }: props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const closeConfrimModal = () => {
    setLogoutConfrim(false);
  };
  const { data } = useSelector((state: RootState) => state.translationData);

  const performLogout = () => {
    eraseCookie("ColibriToken");
    clearStoredRef();
    dispatch(logout());
    navigate("/auth");
  };

  const handleLogout = () => {
    userLogout()
      .then((response) => {
        if (response.status === 200) {
          performLogout();
        }
      })
      .catch(() => {
        // API 403 or other error — still clear session locally
        performLogout();
      });
  };

  return (
    <GlobalModalComponent isOpen={logoutConfrim} onClose={closeConfrimModal}>
      <div className={styles.loogout_modal}>
        <h3 className={styles.title}>{data?.auth_logout_question}</h3>
        <div className={styles.buttons}>
          <MainButton
            className={styles.confrim}
            onClick={handleLogout}
            text={data?.auth_logout_yes}
          />
          <MainButton
            className={styles.cancel}
            onClick={closeConfrimModal}
            text={data?.auth_logout_no}
          />
        </div>
      </div>
    </GlobalModalComponent>
  );
};

export default LogoutModal;
